import React, { useEffect, useState } from 'react'
import $ from 'jquery'
export default function Projectlink() {
    const [clientlinks, setClientlinks] = useState([]);
    const [alerttext, setAlerttext] = useState('');
    const [companyname, setCompanyname] = useState('');
    const [selectedComLogo, setSelectedComLogo] = useState('');
    const [clientName, setClientName] = useState('');
    const [clientEmail, setClientEmail] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [projectArrayDepth, setProjectArrayDepth] = useState(0);
    const [listProjectArray, setListProjectArray] = useState([]);
    const [membretype, setMembertype] = useState(false);
    const baseURL = "https://siddhartha.utopa.in/client-view.php?token=";
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        let comname = localStorage.getItem('mem_company_name');
        setCompanyname(comname);

        var comlogo = localStorage.getItem('companylogo');
        setSelectedComLogo(comlogo);
        loadClientList();


    }, []); // ✅ IMPORTANT

    function loadClientList() {
        let com_id = localStorage.getItem('mem_company_id');

        fetch('get_client_links.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ com_id })
        })
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data) && data.length > 0) {
                    setClientlinks(data);
                } else {
                    setAlerttext("No client found");
                }
            });
    }

    useEffect(() => {
        var company_id = localStorage.getItem('mem_company_id');
        var obj = {
            companyId: company_id
        }
        $.ajax({
            type: 'POST',
            url: 'getAllProjects.php',
            data: obj,
            cache: false,
            success: function (result) {
                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                    } else {
                        showAlert('No active projects found for your company.');
                        setListProjectArray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load project data.');
                    setListProjectArray([]); // fallback to prevent map crash
                }
            },
        });
    }, [])


    const resendLink = (item) => {
        document.getElementById('resendbtn').classList.add('nodisplay')
        let company_email = localStorage.getItem('useremail');
        let company_name = localStorage.getItem('mem_company_name');
        fetch('resend_client_link.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: item.cl_email,
                name: item.cl_name,
                project: item.pro_name,
                token: item.access_token,
                deadline: item.pro_dead_line,
                company_email: company_email,
                company_name: company_name
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.status === 'success') {
                    document.getElementById('resendbtn').classList.remove('nodisplay')
                    showAlert("Email sent successfully");
                } else {
                    document.getElementById('resendbtn').classList.remove('nodisplay')
                    showAlert("Failed to send email");
                }
            });
    };

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function openGuestForm() {
        setShowPopup(true);
    }
    function closeGuestForm() {
        setShowPopup(false);
    }

    function getAllrecords(indexval) {
        setProjectArrayDepth(indexval)
    }

    function submitclient() {
        var gust_id = generateRandomID();
        var gust_name = clientName;
        var gust_email = clientEmail;
        var prodeadline = listProjectArray[projectArrayDepth].pr_last_date;
        let company_email = localStorage.getItem('useremail');
        let company_name = localStorage.getItem('mem_company_name');
        let project_id = listProjectArray[projectArrayDepth].primary_key;
        let project_name = listProjectArray[projectArrayDepth].pro_name;
        var member_com_id = localStorage.getItem('mem_company_id');

        var obj = {
            pro_id: project_id,
            pro_name: project_name,
            gust_id: gust_id,
            cl_name: gust_name,
            com_id: member_com_id,
            cl_email: gust_email,
            pro_dead_line: prodeadline,
            company_email: company_email,
            company_name: company_name
        }
        $.ajax({
            type: 'POST',
            url: 'save_the_guest.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result);
                if (result.status === "success") {
                    showAlert("Client added successfully");
                    closeGuestForm();
                    loadClientList();
                } else {
                    alert('Something went wrong');
                }
            },
        });
    }
    function generateRandomID(length = 8) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }

    
    return (

        <div>
            <div className='editbtn_holder'>
                <div className='membersinfoimg fullwidth'>
                    <div className='memberimgholder'>
                        <img id="memimg" src={selectedComLogo} />
                    </div>
                    <h2 id="companyname">{companyname}</h2>
                </div>
            </div>
            <div className='vl_alltab'>
                <button className='tabs'>Client List of {companyname} </button>
                <button className='tabs_right' onClick={openGuestForm}>Add Client</button>
            </div>
            <section className='vl_dsh_bodypart_section pos_rel'>
                <div className='vl_listing_area'>
                    <div className='vl_listing_row'>
                        <div className='vl_listing_cell width20'>
                            <h4 className='prj_name'>Client Name</h4>
                        </div>
                        <div className='vl_listing_cell width20'>
                            <p>Project name</p>
                        </div>


                        <div className='vl_listing_cell width40'>
                            <p>Link</p>
                        </div>
                        <div className='vl_listing_cell width10'>
                            <p>Action</p>
                        </div>

                    </div>
                    <h3 className='noticetext'>{alerttext}</h3>
                    {Array.isArray(clientlinks) && clientlinks.map((item, index) => (
                        <div className="vl_listing_row" key={item.primary_key || index}>

                            <div className="vl_listing_cell width20">
                                <h4 className="prj_name">
                                    {item.cl_name}
                                </h4>
                            </div>

                            <div className="vl_listing_cell width20">
                                <h4 className="prj_name">
                                    {item.pro_name}
                                </h4>

                            </div>


                            <div className="vl_listing_cell width40">
                                <p>
                                    <a
                                        href={baseURL + item.access_token}
                                        target="_blank"
                                    >
                                        {baseURL + item.access_token}
                                    </a>
                                </p>
                            </div>

                            <div className="vl_listing_cell width20">
                                <button className='mr-10' onClick={() => resendLink(item)} id="resendbtn">
                                    <i class="ri-arrow-go-forward-fill" title="Resend Link"></i>
                                </button>
                                <button onClick={() => navigator.clipboard.writeText(baseURL + item.access_token)}> <i class="ri-file-copy-line" TITLE="Copy"></i></button>
                            </div>



                        </div>
                    ))}
                </div>
            </section>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
            {showPopup && (
                <div className="vl_dsh_popup_vis">
                    <div className="detailsbox p-50">
                        <div className='fullwidth pull_left'>
                            <button className="section_pop_clsoe" onClick={closeGuestForm}>X</button>
                        </div>
                        <h3 className='section_pop_heading'>Add New Client</h3>

                        <div className='section_fieldholder'>
                            <label>Please select a project.</label>
                            <select id="all_projects" onChange={(e) => getAllrecords(e.target.value)}>
                                {listProjectArray.map((project, index) => (
                                    <option key={project.primary_key} value={index}>
                                        {project.pro_name}
                                    </option>
                                ))}
                            </select>
                        </div>


                        <div className='fullwidth pull_left pt-24'>
                            <p className='headingtext'>Please give detail of your client.</p>
                        </div>

                        <div className='section_pop_form'>
                            <div className='section_fieldholder'>
                                <div className='fullwidth pull_left'>
                                    <div className='vl_dsh_one_full'>
                                        <div className='section_fieldholder'>
                                            <label>Client Name</label>
                                            <input
                                                type="text"
                                                value={clientName}
                                                onChange={(e) => setClientName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='fullwidth pull_left'>
                                    <div className='vl_dsh_one_full'>
                                        <div className='section_fieldholder'>
                                            <label>Client Email</label>
                                            <input
                                                type="email"
                                                value={clientEmail}
                                                onChange={(e) => setClientEmail(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>


                                <div className='vl_dsh_buttonholder'>
                                    <button onClick={submitclient}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )}
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
